const specialCharacters = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;

export const testAlphabeticString = (value: string): boolean => {
    const result = !(/\d/.test(value) || specialCharacters.test(value));
    return result;
};
